import React, { useState, useEffect } from 'react';
import { DateUtils } from '../../utils/DateUtils.js';
import APIUtils from '../../utils/APIUtils';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../uiComponents/MuiTable/StyledTable.js'
import MuiTableHeader from '../../uiComponents/MuiTable/MuiTableHeader';
import { stableSort, getComparator } from '../../uiComponents/MuiTable/MuiHelper';
import LoadingInner from '../Loading/LoadingInner';
import { 
  TableBody,
  TableContainer,
} from '@mui/material';

//Important: The id here must match the column name in the returned data. Label can be different for display.
const headCells = [
  { label: 'Program', id: 'programId', numeric: false, disablePadding: false },
  { label: 'Date', id: 'interpretedDate', numeric: false, disablePadding: false },
  { label: 'NBS Program Classification', id: 'programClassification', numeric: false, disablePadding: false },
  { label: 'Comments', id: 'comment', numeric: false, disablePadding: false },
  { label: 'Tags', id: 'tagsDisplay', numeric: false, disablePadding: false },
];

const ConsensusReviews = ({ variantId }) => {
  const [interpretations, setInterpretations] = useState([]);
  const [interpretationsExist, setInterpretationsExist] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [order, setOrder] = useState('desc'); //default sort direction
  const [orderBy, setOrderBy] = useState(''); //default sort column for table
  
  const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
  };
    
  useEffect(() => {
    if (variantId) {
      console.log('getting interpretations again');
      getConsensusReviews(variantId);
    }
  }, [variantId]); // This will run whenever variantId changes

  const getConsensusReviews = async (variantId) => {
    console.log('---getConsensusReviews()');
    setLoading(true);

    const response = await APIUtils.getFinalVariantInterpretations(variantId);

    if (response) {
      const dataForUi = [];
      const interpretationsList = response.variantInterpretations;

      for (let programId in interpretationsList) {
        const interp = interpretationsList[programId];
        const tags = Array.isArray(interp.tags) ? interp.tags : [];

        const myInterpretation = {
          programId,
          interpretedDate: interp.interpretedDate,
          programClassification: interp.programClassification,
          comment: interp.comment,
          status: interp.interpretationStatus,
          tagsDisplay: tags.sort((a, b) => a.localeCompare(b)).join(', '),
        };
        dataForUi.push(myInterpretation);
      }
      if (dataForUi.length) {
        console.info('there were results');
        setInterpretations(dataForUi);
        setInterpretationsExist(dataForUi[0].status === 'Completed');
        setErrorMsg('');
      } else {
        console.info('nothing found');
        setInterpretationsExist(false);
        setErrorMsg('No interpretations found');
      }
    } else {
      setErrorMsg('There was an error retrieving the data.');
      setInterpretationsExist(false);
    }
    setLoading(false);
  };

  return (
    <div>
      {loading ? (
        <LoadingInner isLoadingInner={loading} />
      ) : interpretationsExist ? (
        <div>
          <StyledPaper>
            <TableContainer>
              <StyledTable
                
                size='small'
                aria-label="consensus reviews table" >
                <MuiTableHeader 
                  headCells={headCells} 
                  order={order}  
                  orderBy={orderBy} 
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {stableSort(interpretations, getComparator(order, orderBy))
                    .map((row, index) => {
                    return (
                      <StyledTableRow tabIndex={-1} key={index}>
                        <StyledTableCell style={{width: '15%'}}>{row.programId}</StyledTableCell>
                        <StyledTableCell>{DateUtils.FormatLocalDate(row.interpretedDate)}</StyledTableCell>
                        <StyledTableCell style={{width: '20%'}}>{row.programClassification}</StyledTableCell>
                        <StyledTableCell style={{width: '30%'}}>{row.comment}</StyledTableCell>
                        <StyledTableCell style={{width: '30%'}}>{row.tagsDisplay}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </StyledPaper>
        </div>
      ) : (
        <div className="headerText">
          There are no final consensus reviews for this variant yet
        </div>
      )}
    </div>
  );
};

export default ConsensusReviews;